import "./jquery";
import twigVariables from "@kdose/symfony-bootstrap/js/twigVariables";

const twigVars = twigVariables();

// Caching
const $secondPerson = $(".secondPerson");
const $secondPayer = $(".secondPayer");
const $addSecondPerson = $("#addSecondPerson");
const $addSecondPayer = $("#addSecondPayer");
const $personTitle = $(`#${twigVars.titleid}`);
const $personName = $(`#${twigVars.nameid}`);
const $personSurname = $(`#${twigVars.surnameid}`);
const $secondPersonTitle = $(`#${twigVars.titlesecondid}`);
const $secondPersonName = $(`#${twigVars.namesecondid}`);
const $secondPersonSurname = $(`#${twigVars.surnamesecondid}`);
const $payerTitle = $(`#${twigVars.payertitleid}`);
const $payerName = $(`#${twigVars.payernameid}`);
const $payerSurname = $(`#${twigVars.payersurnameid}`);
const $secondPayerTitle = $(`#${twigVars.secondpayertitleid}`);
const $secondPayerName = $(`#${twigVars.secondpayernameid}`);
const $secondPayerSurname = $(`#${twigVars.secondpayersurnameid}`);

const hideInput = (inputEl) => {
	inputEl.parents(".form-group").addClass("hide");
};

const showInput = (inputEl) => {
	inputEl.parents(".form-group").removeClass("hide");
};

const changeLabel = (inputEl, newText) => {
	inputEl.parents(".form-group").find("label").text(newText);
};

const changeRequired = (inputEl, required) => {
	inputEl.attr("required", required);

	const label = inputEl.parents(".form-group").find("label");

	if (required) {
		label.addClass("required");
	} else {
		label.removeClass("required");
	}
};

// Zweiten Kontoinhaber zum Togglen ausblenden
if (
	$secondPersonTitle.val() === "" &&
	$secondPersonName.val() === "" &&
	$secondPersonSurname.val() === ""
) {
	$secondPerson.addClass("hide");
	$addSecondPerson
		.on("click", function () {
			$secondPerson.removeClass("hide");
			$(this).addClass("hide");
			return false;
		})
		.removeClass("hide");
}

// Zweiten Zahlungspflichtigen zum Togglen ausblenden
if (
	$secondPayerTitle.val() === "" &&
	$secondPayerName.val() === "" &&
	$secondPayerSurname.val() === ""
) {
	$secondPayer.addClass("hide");
	$addSecondPayer
		.on("click", function () {
			$secondPayer.removeClass("hide");
			$(this).addClass("hide");
			return false;
		})
		.removeClass("hide");
}

// Dynamische Anpassung bei Firmenauswahl/-abwahl

// Erster Kontoinhaber
$personTitle
	.change(function () {
		if ($(this).val() === "Firma") {
			changeLabel($personSurname, "Firmenname");
			changeRequired($personSurname, true);

			changeRequired($personName, false);
			hideInput($personName);
		} else {
			changeLabel($personSurname, "Nachname");
			changeRequired($personSurname, true);

			changeRequired($personName, true);
			showInput($personName);
		}
	})
	.trigger("change");

// Zweiter Kontoinhaber
$secondPersonTitle
	.change(function () {
		if ($(this).val() === "Firma") {
			changeLabel($secondPersonSurname, "Firmenname");
			changeRequired($secondPersonSurname, true);

			changeRequired($secondPersonName, false);
			hideInput($secondPersonName);
		} else if ($(this).val() !== "") {
			changeLabel($secondPersonSurname, "Nachname");
			changeRequired($secondPersonSurname, true);

			changeRequired($secondPersonName, true);
			showInput($secondPersonName);
		} else {
			changeLabel($secondPersonSurname, "Nachname");
			changeRequired($secondPersonSurname, false);

			changeRequired($secondPersonName, false);
			showInput($secondPersonName);
		}
	})
	.trigger("change");

// Erster Zahlungspflichtige
$payerTitle
	.change(function () {
		if ($(this).val() === "Firma") {
			changeLabel($payerSurname, "Firmenname");
			changeRequired($payerSurname, true);

			changeRequired($payerName, false);
			hideInput($payerName);
		} else if ($(this).val() !== "") {
			changeLabel($payerSurname, "Nachname");
			changeRequired($payerSurname, true);

			changeRequired($payerName, true);
			showInput($payerName);
		} else {
			changeLabel($payerSurname, "Nachname");
			changeRequired($payerSurname, false);

			changeRequired($payerName, false);
			showInput($payerName);
		}
	})
	.trigger("change");

// Zweiter Zahlungspflichtige
$secondPayerTitle
	.change(function () {
		if ($(this).val() === "Firma") {
			changeLabel($secondPayerSurname, "Firmenname");
			changeRequired($secondPayerSurname, true);

			changeRequired($secondPayerName, false);
			hideInput($secondPayerName);
		} else if ($(this).val() !== "") {
			changeLabel($secondPayerSurname, "Nachname");
			changeRequired($secondPayerSurname, true);

			changeRequired($secondPayerName, true);
			showInput($secondPayerName);
		} else {
			changeLabel($secondPayerSurname, "Nachname");
			changeRequired($secondPayerSurname, false);

			changeRequired($secondPayerName, false);
			showInput($secondPayerName);
		}
	})
	.trigger("change");
